import createActionsProxy, { ActionsProxy } from './createActionsProxy';

export {
  createActionsProxy,
  ActionsProxy
}